import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class RedirectService {
  constructor(private router: Router) { }

  public redirect(to: string): boolean {
    if (this.isAllowedExternal(to)) {
      console.info("RedirectService.redirect - domain allowed, navigating to:", to);
      window.location.href = to;
      return true;
    } else {
      console.error("RedirectService.redirect - BLOCKED: domain not allowed", to);
      return false;
    }
  }

  isAllowedExternal(url: string): boolean {
    try {
      const { hostname } = new URL(url);
      const allowed = hostname === "ns.nl" || hostname.endsWith(".ns.nl") || hostname === "nsinternational.com" || hostname.endsWith(".nsinternational.com");
      if (!allowed) {
        console.warn("RedirectService.isAllowedExternal - hostname not in allow-list:", hostname);
      }
      return allowed;
    } catch (err) {
      console.warn("RedirectService.isAllowedExternal - failed to parse URL, treating as not allowed:", url, err);
      return false;
    }
  }
}
